import React from "react"
import { Alert, } from "@fedsim/components"

const Types = {
  DEFAULT: "Error occured",
  required: "Field requires input",
  max: "Maximum reached",
  min: "Minimum reached",
}

export const FormError = ({ type = "DEFAULT", }) => {

  return (
    <Alert severity="error">
      {Types[type]}
    </Alert>
  )
}

export default FormError
